import $ from 'jquery';
import './animated-counter';

export const animatedDigits = ($target: JQuery<HTMLElement>, $parent: JQuery<HTMLElement>, duration: number) => {

  let done = false;
  let visibilityDone = false;
  const text = $target.text();
  const newText = text.replace(/\d+/g, '<span data-end="$&">0</span>');
  // hide $target instead of set newText to let other plugin calculate the good height of the target or is parent
  $target.css('visibility', 'hidden');

  const animation = () => {
    const winHeight = $(window).height();
    const windowPos = $(window).scrollTop();
    const targetPos = $parent.offset().top;

    if (windowPos + winHeight > targetPos && visibilityDone === false) {
      // show target and set newText before entre in the viewport
      visibilityDone = true;
      $target.html(newText);
      $target.css('visibility', 'visible');
    }

    if (windowPos + winHeight > targetPos + Math.round($parent.height() / 3) && done === false) {
      done = true;
      $('span', $target).each(function (i) {
        const $span = $(this);
        const startNumber = $span.text();
        const endNumber = $span.attr('data-end');
        if (parseInt(endNumber, 10) !== 0) {
          $span.delay(duration * (i + 1)).animatedCounter({
            start: startNumber,
            end: endNumber,
            duration,
          });
        }
        else {
          $span.text(endNumber);
        }
      });
    }
  };

  animation();
  $(window).scroll(animation);
};
